import EVENTS from '../../constants/xray-ui_events.constants';

export class XrayFooterDao {
    constructor($rootScope, XRAY_RESOURCE, XRayUIDaoFactory, XRayUIStorage, $timeout, JFrogEventBus, XRayUIState) {
        this.storage = XRayUIStorage;
        this.XRayUIState = XRayUIState;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.JFrogEventBus = JFrogEventBus;
        this._resource = XRayUIDaoFactory()
            .setPath(XRAY_RESOURCE.FOOTER)
            .getInstance();
    }

    get(force = false) {

        if (!this.cached || force) {
            this.cached = this._resource.get({$no_spinner: true}).$promise;

            this.cached.then(info => {
                this._info = info;
                if (info.isSaas) {
                    this.XRayUIState.setState('isSaas', info.isSaas);
                } else {
                    this.XRayUIState.setState('isSaas', false);
                }
                this.JFrogEventBus.dispatch(EVENTS.FOOTER_DATA_UPDATED);
            });
        }

        //Fix for RTFACT-9873
        if (!this._info) {
            this.$timeout(() => {
                if (!this._info) {
                    this.get(true).then(() => {
                        this.JFrogEventBus.dispatch(EVENTS.FOOTER_DATA_UPDATED);
                    });
                }
            }, 400);
        }

        return this.cached;
    }

    getInfo() {

        return this._info;
    }
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/footer_dao.js